import React, { useState } from "react";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

export default function AccountingLogin() {
  const auth = getAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = async (e) => {
    e.preventDefault();

    try {
      const res = await signInWithEmailAndPassword(auth, email, password);
      const snap = await getDoc(doc(db, "account_users", res.user.uid));

      if (!snap.exists()) {
        toast.error("Accounting access not found");
        return;
      }

      const user = snap.data();

      if (!user.active) {
        toast.error("Account inactive");
        return;
      }

      if (!["ACCOUNTANT", "CEO"].includes(user.role)) {
        toast.error("Only Accountant / CEO allowed");
        return;
      }

      navigate("/accounting");
    } catch (err) {
      toast.error(err.message || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
      <Toaster position="top-center" />

      <form
        onSubmit={login}
        className="w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl"
      >
        <h1 className="text-2xl font-black text-slate-900">
          Accounting Login
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Accountant / CEO approval system
        </p>

        <div className="mt-6 space-y-4">
          <input
            className="w-full border rounded-xl px-4 py-3"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            className="w-full border rounded-xl px-4 py-3"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className="w-full bg-emerald-600 text-white rounded-xl py-3 font-bold">
            Login
          </button>
        </div>
      </form>
    </div>
  );
}